import { Button } from '@/components/UI';
import DataTable from '@/components/UI/DataTable';
import type { ScreenerOptimizerFeatureAnalysisRow } from '@/types/appRouter';
import { featureAnalysisColumns } from './featureAnalysisColumns';

interface FeaturesSectionProps {
    features: ScreenerOptimizerFeatureAnalysisRow[];
    isError: boolean;
    errorMessage: string | undefined;
    isFetching: boolean;
    onOpenFeatureImpact: () => void;
}

const FeaturesSection = ({ features, isError, errorMessage, isFetching, onOpenFeatureImpact }: FeaturesSectionProps) => {
    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div className="text-zinc-500 text-xs">
                    Univariate feature analysis showing each feature&apos;s best single-threshold performance. Ranked by sweet score.
                </div>
                <Button
                    size="sm"
                    title="See which features matter and how they appear in the best combinations."
                    variant="secondary"
                    onClick={onOpenFeatureImpact}
                >
                    Feature impact
                </Button>
            </div>
            {isError && <div className="text-red-300 text-sm mb-2">Failed to load features: {errorMessage ?? 'Unknown error'}</div>}
            {isFetching && features.length === 0 ? (
                <div className="text-zinc-400 text-sm">Loading feature analysis…</div>
            ) : features.length === 0 && !isError ? (
                <div className="text-zinc-400 text-sm">No feature analysis data yet.</div>
            ) : features.length > 0 ? (
                <DataTable
                    allowOverflow
                    search
                    columns={featureAnalysisColumns}
                    data={features}
                    pagination={{ enabled: true, pageSize: 20 }}
                />
            ) : null}
        </>
    );
};

export default FeaturesSection;
